import React from 'react';
import loadable from '@loadable/component';

const Destinations = loadable(() => import('../components/Destinations/Destinations'));

const DestinationsPage = () => <Destinations/>;


export default DestinationsPage;